import { isEmbedLatched, EMBED_QUERY_PARAM, EMBED_QUERY_VALUE } from '@/utils/embed'

// In embed mode, keep `?embed=1` in the URL across internal navigations that would
// otherwise drop it (selecting an event, etc.), so reloads preserve embed mode.
// Returns a redirect location that re-adds the param, or null to let navigation proceed.
// Gated by the session latch, so normal (non-embed) tabs are never redirected.
export const embedNavigationTarget = (to) => {
  if (
    isEmbedLatched() &&
    to.path.includes('/workflow/') &&
    to.query[EMBED_QUERY_PARAM] !== EMBED_QUERY_VALUE
  ) {
    return {
      path: to.path,
      query: { ...to.query, [EMBED_QUERY_PARAM]: EMBED_QUERY_VALUE },
      hash: to.hash
    }
  }

  return null
}
